<div class="portfolio-page">
  <header class="portfolio-header">
    <p class="eyebrow">Portfolio</p>
    <h1>Selected projects</h1>
    <p class="intro">
      I design and build practical software products, from Android apps to backend services,
      with a focus on clean interfaces and reliable engineering.
    </p>
  </header>

  <div class="project-grid">
    <article class="project-card">
      <div class="card-image">
        <a routerLink="/portfolio/endless-blow"><img src="assets/images/endless_blow_app_icon.png" alt="Endless Blow" /></a>
      </div>
      <div class="card-body">
        <div class="card-meta">
          <span>Android</span>
          <span>Java</span>
        </div>
        <h2><a routerLink="/portfolio/endless-blow">Endless Blow</a></h2>
        <p>Game app built around a competitive, replayable loop with a polished mobile UX.</p>
        <div class="tech-stack">
          <span>SQLite</span>
          <span>Game</span>
        </div>
      </div>
    </article>

    <article class="project-card">
      <div class="card-image">
        <a routerLink="/portfolio/objects-measurement"><img src="assets/images/objects_measure_app.icon.png" alt="Objects Measurements" /></a>
      </div>
      <div class="card-body">
        <div class="card-meta">
          <span>Java</span>
          <span>Vision</span>
        </div>
        <h2><a routerLink="/portfolio/objects-measurement">Objects Measurements</a></h2>
        <p>Measurement utility combining mobile capture and computer vision to estimate object size.</p>
        <div class="tech-stack">
          <span>Android</span>
          <span>SQLite</span>
        </div>
      </div>
    </article>

    <article class="project-card">
      <div class="card-image">
        <a routerLink="/portfolio/dribbler"><img src="assets/images/dribbler_app_icon.png" alt="Dribbler" /></a>
      </div>
      <div class="card-body">
        <div class="card-meta">
          <span>Games</span>
          <span>Android</span>
        </div>
        <h2><a routerLink="/portfolio/dribbler">Dribbler</a></h2>
        <p>Arcade gameplay experiment centered on responsiveness, physics, and fun interaction.</p>
        <div class="tech-stack">
          <span>Java</span>
          <span>Android</span>
        </div>
      </div>
    </article>

    <article class="project-card">
      <div class="card-image">
        <a routerLink="/portfolio/notepad"><img src="assets/images/simple_notepad_app_icon.png" alt="Notepad" /></a>
      </div>
      <div class="card-body">
        <div class="card-meta">
          <span>Productivity</span>
          <span>Mobile</span>
        </div>
        <h2><a routerLink="/portfolio/notepad">Notepad</a></h2>
        <p>Simple note-taking app designed around accessibility and quick capture workflows.</p>
        <div class="tech-stack">
          <span>Java</span>
          <span>Android</span>
        </div>
      </div>
    </article>

    <article class="project-card">
      <div class="card-image">
        <a routerLink="/portfolio/app-location"><img src="../../../assets/images/app_location_app_icon.png" alt="App With Location Service" /></a>
      </div>
      <div class="card-body">
        <div class="card-meta">
          <span>Google Maps</span>
          <span>Android</span>
        </div>
        <h2><a routerLink="/portfolio/app-location">App With Location Service</a></h2>
        <p>Context-aware mobile solution that uses live location data to support user needs.</p>
        <div class="tech-stack">
          <span>Java</span>
          <span>Android</span>
        </div>
      </div>
    </article>

    <article class="project-card">
      <div class="card-image">
        <a routerLink="/portfolio/product-notes"><img src="assets/images/products_notes_app_icon.png" alt="Product Notes" /></a>
      </div>
      <div class="card-body">
        <div class="card-meta">
          <span>Food &amp; Drink</span>
          <span>Android</span>
        </div>
        <h2><a routerLink="/portfolio/product-notes">Product Notes</a></h2>
        <p>Barcode-based product notes that help people remember which food and drinks suit them.</p>
        <div class="tech-stack">
          <span>Kotlin</span>
          <span>Barcode scanner</span>
        </div>
      </div>
    </article>

    <article class="project-card">
      <div class="card-image exchange-rates-mark">
        <a routerLink="/portfolio/exchange-rates"><img src="assets/images/exchange_rates_app_icon.png" alt="AssocWords" /></a>
      </div>
      <div class="card-body">
        <div class="card-meta">
          <span>Finance</span>
          <span>Android</span>
        </div>
        <h2><a routerLink="/portfolio/exchange-rates">Exchange Rates</a></h2>
        <p>Android app for checking live exchange-rate history with a bilingual, swipe-driven experience.</p>
        <div class="tech-stack">
          <span>Kotlin</span>
          <span>REST API</span>
        </div>
      </div>
    </article>

    <article class="project-card">
      <div class="card-image">
        <a routerLink="/portfolio/assoc-words"><img src="assets/images/assocwords_app_icon.png" alt="AssocWords" /></a>
      </div>
      <div class="card-body">
        <div class="card-meta">
          <span>Education</span>
          <span>Android</span>
        </div>
        <h2><a routerLink="/portfolio/assoc-words">AssocWords</a></h2>
        <p>Community-powered language learning that turns memorable associations into lasting vocabulary.</p>
        <div class="tech-stack">
          <span>Kotlin</span>
          <span>Language learning</span>
        </div>
      </div>
    </article>

    <article class="project-card">
      <div class="card-image">
        <a routerLink="/portfolio/rick-and-morty"><img src="assets/images/rick_and_morty_app_icon.png" alt="Rick and Morty App" /></a>
      </div>
      <div class="card-body">
        <div class="card-meta">
          <span>Android</span>
          <span>Kotlin</span>
        </div>
        <h2><a routerLink="/portfolio/rick-and-morty">Rick and Morty App</a></h2>
        <p>Kotlin Android application for browsing Rick and Morty data from a public API.</p>
        <div class="tech-stack">
          <span>MVP</span>
          <span>REST API</span>
        </div>
      </div>
    </article>

    <article class="project-card">
      <div class="card-image audio-processing-mark">
        <a routerLink="/portfolio/ai-based-audio-processing"><img src="assets/images/ai_based_audio_processing_app_icon.png" alt="AI Based Audio Processing App" /></a>
      </div>
      <div class="card-body">
        <div class="card-meta">
          <span>Android</span>
          <span>AI</span>
        </div>
        <h2><a routerLink="/portfolio/ai-based-audio-processing">AI-Based Audio Processing</a></h2>
        <p>Meeting assistant concept for transcription, transcript chat, summaries, and calendar integration.</p>
        <div class="tech-stack">
          <span>Audio processing</span>
          <span>Offline-first</span>
        </div>
      </div>
    </article>
  </div>
</div>
